export const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://port-0-household-book-back-rccln2llvsdixmg.sel5.cloudtype.app"
    : "http://localhost:8090";
